<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>{{ header }} Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                v-bind:search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0 && isDefAll" class="small font-weight-light grey--text">
                Note: Default is "All" if no item is selected.
              </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', header)">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', header)">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { helpListMixin } from '@/mixins/common/helpListMixin'
export default {
  props: {
    apiURI: String,
    mode: String,
    param: String,
    defAll: Boolean,
    boolRefresh: Boolean
  },
  data() {
    return {
      headers: [
        { text: 'Branch', value: 'id' },
        { text: 'Description', value: 'desc' }
      ],
      header: '',
      selected: [],
      parameter: [],
      items: [],
      paramItems: [],
      apiUri: '',
      isDefAll: false,
      totalItems: 0,
      selectedItems: [],
      checkedItemsAll: [],
      checkedItems: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      this.doInit()
      this.getLabel()
    }
  },
  created() {
    this.doInit()
    this.getLabel()
  },
  methods: {
    doInit() {
      this.search = ''
      this.items = []
      this.parameter = []
      this.isDefAll = this.defAll
      if (this.param !== null && this.param !== '') {
        this.parameter = this.param.split(',')
      }
      const apiURI = this.apiURI
      if (apiURI) {
        if (this.parameter !== this.checkedItems) {
          this.doReset()
          this.checkedItems = this.parameter
        }
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            this.selectedItems = []
            const { data } = result.data
            if (data) {
              data.map((param) => {
                const convertList = {
                  key: param.value,
                  id: param.value,
                  desc: param.label
                }
                if (this.checkedItems.includes(param.value)) {
                  const branchList = {
                    key: param.value,
                    id: param.value,
                    desc: param.label
                  }
                  this.selectedItems.push(branchList)
                }
                this.items.push(convertList)
              })
            }
            if (this.checkedItems.toString() === 'All' || this.checkedItems.toString() === '') {
              this.doReset()
              this.toggleAll()
            } else {
              this.toggleSelected()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    getLabel() {
      this.headers = []
      this.headers.push({ text: '', value: 'id' })
      // Push a header with empty text for checkboxes
      switch (this.mode) {
        case 'branch':
          this.headers.push({ text: 'Branch', value: 'id' })
          this.header = 'Branch'
          break
        case 'fund':
          this.headers.push({ text: 'Fund', value: 'id' })
          this.header = 'Fund'
          break
        case 'suffix':
          this.headers.push({ text: 'Suffix', value: 'id' })
          this.header = 'Suffix'
          break
        case 'curr':
          this.headers.push({ text: 'Currency', value: 'id' })
          this.header = 'Currency'
          break
        case 'dept':
          this.headers.push({ text: 'Department', value: 'id' })
          this.header = 'Department'
          break
        case 'resCat':
          this.headers.push({ text: 'Reserve Category', value: 'id' })
          this.header = 'Reserve Category'
          break
        case 'matchedBy':
          this.headers.push({ text: 'User Id', value: 'id' })
          this.header = 'Matched By'
          break
        case 'polType':
          this.headers.push({ text: 'Policy Type', value: 'id' })
          this.header = 'Policy Type'
          break
      }
      this.headers.push({ text: 'Description', value: 'desc' })
    },
    closeDialog() {
      this.$emit('close')
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>

<style>
</style>
